import clsx from 'clsx';
import React from 'react';
import AddIcon from '../../assets/icons/add-icon.svg?react';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import Input from '../Input';
import { FormikProps } from 'formik';
import { CreateDepartmentDTO } from '@EHSNavigator/backend';

interface AddDepartmentProps {
  otherClasses?: string;
  formHandler: FormikProps<CreateDepartmentDTO>;
  handleClose: () => void;
}

const AddDepartmentModal: React.FC<AddDepartmentProps> = ({
  otherClasses,
  formHandler,
  handleClose,
}) => {
  const AddDepartmentasses = clsx(otherClasses);

  return (
    <div
      className={AddDepartmentasses}
      data-testid="edit-department-details-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <AddIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-byzantine">Add New Department</h4>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <div className="mt-2.5 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label="Department Name"
            errorMessage={
              formHandler?.touched.name && formHandler?.errors.name
                ? formHandler?.errors.name
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.name}
            type="text"
            placeholder="Type here department name..."
            onChange={formHandler?.handleChange}
            name="name"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="mt-8 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label="Department Prefix"
            errorMessage={
              formHandler?.touched.prefix && formHandler?.errors.prefix
                ? formHandler?.errors.prefix
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.prefix}
            type="text"
            placeholder="Example (SH)"
            onChange={formHandler?.handleChange}
            name="prefix"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={useButtonSizeSmall()}
            onClick={() => {
              formHandler.resetForm();
              handleClose();
            }}
            otherClasses="border-transparent text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Discard Changes
          </Button>
          <Button
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            type="submit"
            size={useButtonSizeSmall()}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddDepartmentModal;
